import { cn } from '@/lib/cn';
import type { JSX } from 'solid-js';

type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

const TONES: Record<Tone, string> = {
  neutral: 'bg-neutral-100 text-neutral-800 dark:bg-neutral-800 dark:text-neutral-200',
  success: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200',
  warning: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
  danger: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200',
  info: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200',
};

export interface BadgeProps {
  tone?: Tone;
  children: JSX.Element;
  class?: string;
}

export const Badge = (props: BadgeProps): JSX.Element => (
  <span
    class={cn(
      'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
      TONES[props.tone ?? 'neutral'],
      props.class,
    )}
  >
    {props.children}
  </span>
);
